import {useDarkMode} from "../../contexts/darkModeContext";
import React from "react";
import {convertUnit, textColorMap} from "../GlobalFunctions";

const NutrientCard = ({nutrient, Vol, Weight, galVol, index, metric, type}) => {
    const percent = nutrient.percentage / 100;
    const { darkMode } = useDarkMode();

    // const handleDivision = (value, metric) => {
    //     if (value < 0.1) {
    //         const ozValue = value * 16; // Convert lbs to oz
    //         return convertUnit(ozValue, "oz", metric).value + " " + convertUnit(ozValue, "oz", metric).unit;
    //     } else {
    //         return convertUnit(value, "lbs", metric).value + " " + convertUnit(value, "lbs", metric).unit;
    //     }
    // };

    const handleDivision = (value, metric) => {
        if (value < 0.1) {
            const ozValue = value * 16; // Convert lbs to oz
            const { value: convertedValue, unit } = convertUnit(ozValue, "oz", metric);
            return (
                <>
                    {convertedValue} <span className="text-gray-500">{unit}</span>
                </>
            );
        } else {
            const { value: convertedValue, unit } = convertUnit(value, "lbs", metric);
            return (
                <>
                    {convertedValue} <span className="text-gray-500">{unit}</span>
                </>
            );
        }
    };

    return (

        <tr key={index} className={`border-b-2 ${darkMode ? 'border-neutral-700' : ''} items-center`}>
            <td className="max-w-0 px-0 py-3 align-top">
                <div className="truncate text-sm font-medium tracking-widest">{nutrient.name}</div>
                <div className={`truncate text-xs mt-1 ${textColorMap[type] || 'text-gray-500'} flex items-center tracking-tighter font-semibold`}>{nutrient.percentage}% <span className={`text-gray-500 tracking-normal font-light ml-2 text-xs`}>makeup of the product</span></div>
            </td>
            <td className="hidden py-5 pl-8 pr-0 text-right align-top tabular-nums sm:table-cell">
                {handleDivision(percent * Weight, metric)}
            </td>
            <td className="hidden py-5 pl-8 pr-0 text-right align-top tabular-nums sm:table-cell">
                {handleDivision(percent * Weight * galVol, metric)}
            </td>
            <td className="py-5 pl-8 pr-0 text-right align-top tabular-nums">
                {handleDivision(percent * Weight * Vol, metric)}
            </td>
        </tr>

    );
};

export default NutrientCard;
